import { Box } from "@mui/material";
import Incomplete from "./incomplete";
import { useTheme } from "../../context/themeContext";
import useProtectedAuth from "../../hooks/useProtectedAuth";
import { useSelector } from "react-redux";

const Discover = () => {
  useProtectedAuth();
  const { theme } = useTheme();
  const user = useSelector((state) => state.user.value);

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: theme.palette.lightgrey.lightgrey500,
        minHeight: "100vh",
        paddingBottom: "5rem",
      }}
    >
      {!user?.isProfileComplete && <Incomplete />}
    </Box>
  );
};

export default Discover;
